'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var between = {};

exports.__exports = between;
